// Never import any server-only code here, this is also used on the client side...
import type { TranslationsMap } from './types';

// Lithuanian version of the translation file
export const translations: TranslationsMap = {
  emails: {
    footer: {
      kindRegards: 'Pagarbiai,',
      questionsOrProblems: 'Klausimai ar problemos?',
      contactUs: 'Susisiekite su mumis',
    },
    transportOrder: {
      confirm: 'Patvirtinti',
      refuse: 'Atmesti',
    },
    forgotPassword: {
      resetLink: 'Nustatyti naują slaptažodį',
    },
    userInvite: {
      view: 'Peržiūrėti kvietimą',
    },
    attachments: {
      quotation: 'Pasiūlymas {{reference}}',
    },
    customerComplaintAlert: {
      order: 'Peržiūrėti užsakymą',
    },
  },
  truckDocumentType: {
    Insurance: 'Draudimas',
    Examination: 'Techninė apžiūra',
  },
  orderDocumentType: {
    cmr: 'CMR',
    deliveryNote: 'Delivery note',
    weighSlip: 'Weigh slip',
    palletNote: 'Pallet note',
    annexII: 'Annex II',
    t1Document: 'T1 document',
    annexVII: 'Annex VII',
    saleInvoice: 'Invoice',
    transportOrder: 'Transport order',
    orderConfirmation: 'Order confirmation',
    sustainabilityReport: 'Sustainability report',
    customerAttachment: 'Customer attachment',
    planning: 'Planning',
    other: 'Other',
  },
  documentRejection: {
    subject: 'Dokumentas atmestas užsakymui {{orderNumber}}',
    intro: 'Negalime patvirtinti gauto {{documentType}} dokumento užsakymui {{orderNumber}}. Priežastys:',
    outro: 'Prašome atsiųsti pataisytą dokumentą įprastu būdu arba per vežėjo portalą.',
    MissingSignature: 'Trūksta gavėjo parašo CMR dokumente.',
    WrongCustomer: 'Dokumento klientas neatitinka šio užsakymo kliento.',
    WrongOrgOnDocument: 'Dokumento siuntėjas/ekspeditorius neatitinka mūsų organizacijos.',
    NoOrderReference: 'Nepavyko rasti tinkamos užsakymo ar sąskaitos nuorodos.',
    WrongDocumentType: 'Dokumento tipas neatitinka šiam užsakymui tikėtino tipo.',
    LowQuality: 'Skenuotos/fotografuotos kopijos kokybė per žema patikimam patvirtinimui.',
  },
  trailerTypes: {
    BoxTrailer: 'Kietasienė priekaba',
    FlatBed: 'Platforma',
    Mega: 'Mega priekaba',
    Refrigerated: 'Refrižeratorius',
    RoadTrain: 'Autotraukinys',
    Tautliner: 'Užuolaidinė priekaba (Tentas)',
    Joloda: 'Tentas / Joloda',
    TautlinerCoil: 'Tentas / Ritininiams kroviniams',
  },
  loadingMethods: {
    Back: 'Galas',
    Side: 'Šonas',
    Top: 'Per stogą',
  },
  documents: {
    note: {
      extraInformation: 'Papildoma informacija',
    },
    letter: {
      letter: 'Laiškas',
    },
    paymentReminder: {
      invoiceNumber: 'Sąskaitos numeris',
      invoiceDate: 'Sąskaitos data',
      dueDate: 'Apmokėjimo terminas',
      amount: 'Suma',
      expiredAmount: 'Pradelsta suma',
      currency: 'Valiuta',
      totalOutstanding: 'Total outstanding',
      salutation: 'Dear Sir or Madam,',
      subject: {
        first: 'Subject: payment reminder — {{reference}}',
        second: 'Subject: second payment reminder — {{reference}}',
        third: 'Subject: third payment reminder — {{reference}}',
        final: 'Subject: notice of default — {{reference}}',
      },
      intro: {
        first:
          'Our records show that the invoices below have not yet been settled. If your payment has crossed with this letter, please disregard it.',
        second: 'Despite our earlier reminder, we have not yet received payment for the invoices below:',
        third: 'Despite repeated reminders, the invoices below are still outstanding:',
        final: 'Despite earlier payment reminders, we have to date received no payment for the invoices below:',
      },
      request:
        'We request that you transfer the outstanding amount of {{amount}} to the account below within {{days}} calendar days of receiving this letter, quoting the reference:',
      acknowledgement:
        'If you do not pay and do not state a reason for this, it will be regarded as an acknowledgement of the debt.',
      escalation: {
        first: 'Should we not receive your payment within this period, we will send you a further reminder.',
        second: 'Should we not receive your payment within this period, we will be obliged to escalate this file.',
        third:
          'Should payment not be made within this period, this file will be transferred to our debt collection procedure.',
        final:
          'Should payment not be made within this period, we will hand this file to our legal counsel without further notice, with instructions to start legal proceedings against you. The costs of this will be entirely at your expense.',
      },
      closing: {
        first: 'We trust you will settle the outstanding amount within the requested period.',
        second: 'We trust you will settle the outstanding amount within the requested period.',
        third: 'We trust you will settle the outstanding amount within the requested period.',
        final:
          'We trust this will not be necessary and that you will settle the outstanding amount within the requested period.',
      },
      sincerely: 'Sincerely,',
      signature: 'Accounting {{company}}',
      account: 'Account {{company}}',
      accounts: '{{company}} sąskaitos',
      reference: 'Reference',
      amountDue: 'Amount due',
      bic: 'BIC',
      heldBy: 'savininkas {{company}}',
      date: 'Date',
      ourReference: 'Our reference',
      customerNumber: 'Customer number',
      yourVatNumber: 'Your VAT number',
      contact: 'Contact',
      phone: 'Phone',
    },
    quotation: {
      quotation: 'Pasiūlymas',
      customerNumber: 'Kliento numeris',
      reference: 'Nuoroda',
      date: 'Pasiūlymo data',
      dueDate: 'Galiojimo pabaigos data',
      from: 'Nuo',
      to: 'Iki',
      volume: 'Tūris',
      price: 'Kaina',
      generalTermsAndConditions: 'Pridedamos bendrosios pardavimo sąlygos',
      questionsOrComments: 'Kilus klausimams, susisiekite su mumis el. paštu {{email}}',
      trailerTypes: 'Priekabų tipai',
    },
    transportOrder: {
      trailerTypes: 'Priekabų tipai',
      loadingMethod: 'Pakrovimo būdas',
      transportOrder: 'Transporto užsakymas',
      date: 'Data',
      orderRef: 'Užsakymo nuoroda',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      reference: 'Nuoroda',
      goods: 'Prekės',
      description: 'Aprašymas',
      packageType: 'Padėklo tipas',
      palletCount: 'Padėklai',
      weight: 'Svoris',
      LoadingMeter: 'Pakrovimo metrai',
      freightRate: 'Frachto tarifas',
      price: 'Kaina',
      vat: 'PVM',
      questionsOrComments: 'Klausimai ar komentarai?',
      contactFileManager: 'Nedvejodami susisiekite su savo failų valdytoju',
      anonymousCmr: 'ŠIAM UŽSAKYMUI BŪTINA SUKURTI ANONIMINĮ CMR.',
      phone: 'Telefonas',
      email: 'El. paštas',
    },
    planning: {
      planning: 'Planavimas',
      licensePlate: 'Valstybinis numeris',
      codeName: 'Kodinis pavadinimas',
    },
    kilometers: {
      full: 'Kilometrai su kroviniu',
      empty: 'Tušti kilometrai',
      total: 'Iš viso kilometrų',
      planningTotal: 'Šio planavimo iš viso',
    },
    orderConfirmation: {
      orderConfirmation: 'Užsakymo patvirtinimas',
      dearCustomer: 'Gerbiamas kliente,',
      herebyWeConfirmYourOrder: 'Šiuo patvirtiname jūsų užsakymą šiam transportui:',
      date: 'Data',
      ourReference: 'Mūsų nuoroda',
      yourReference: 'Jūsų nuoroda',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      reference: 'Nuoroda',
      goods: 'Prekės',
      description: 'Aprašymas',
      packageType: 'Padėklo tipas',
      palletCount: 'Padėklai',
      weight: 'Svoris',
      LoadingMeter: 'Pakrovimo metrai',
      freightRate: 'Frachto tarifas',
      price: 'Kaina',
      vat: 'PVM',
      questionsOrComments: 'Klausimai ar komentarai?',
      contactFileManager: 'Nedvejodami susisiekite su savo failų valdytoju',
      phone: 'Telefonas',
      email: 'El. paštas',
    },
    orderCancellation: {
      orderCancellation: 'Užsakymo atšaukimas',
      dearCustomer: 'Gerbiamas kliente,',
      orderCancelledText: 'Jūsų užsakymas žemiau nurodytam transportui buvo atšauktas:',
      date: 'Data',
      ourReference: 'Mūsų nuoroda',
      yourReference: 'Jūsų nuoroda',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      reference: 'Nuoroda',
      goods: 'Prekės',
      description: 'Aprašymas',
      packageType: 'Padėklo tipas',
      palletCount: 'Padėklai',
      weight: 'Svoris',
      LoadingMeter: 'Pakrovimo metrai',
      freightRate: 'Frachto tarifas',
      price: 'Kaina',
      vat: 'PVM',
      questionsOrComments: 'Klausimai ar komentarai?',
      contactFileManager: 'Nedvejodami susisiekite su savo failų valdytoju',
      phone: 'Telefonas',
      email: 'El. paštas',
    },
    invoice: {
      invoice: 'Sąskaita faktūra',
      customerNumber: 'Kliento numeris',
      invoiceNumber: 'Sąskaitos numeris',
      invoiceDate: 'Sąskaitos data',
      dueDate: 'Apmokėjimo terminas',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      ourReference: 'Mūsų nuoroda',
      yourReference: 'Jūsų nuoroda',
      description: 'Aprašymas',
      quantity: 'Kiekis',
      unitPrice: 'Vieneto kaina',
      total: 'Iš viso',
      vat: 'PVM',
      paymentInformation: 'Mokėjimo informacija',
      amountToPay: 'Mokėtina suma',
      toBePaidBefore: 'Apmokėti iki',
      beneficiary: 'Gavėjas',
      message: 'Pranešimas',
      generalTermsAndConditions: 'Pridedamos bendrosios pardavimo sąlygos',
      questionsOrComments: 'Kilus klausimams, susisiekite su apskaita el. paštu {{email}}',
    },
    sustainabilityReport: {
      sustainabilityReport: 'Tvarumo ataskaita',
      date: 'Data',
      ourReference: 'Mūsų nuoroda',
      yourReference: 'Jūsų nuoroda',
      truck: 'Sunkvežimis',
      distance: 'Atstumas',
      weight: 'Svoris',
      emissions: 'Emisijos',
      questionsOrComments: 'Klausimai ar pastabos?',
      contactFileManager: 'Nedvejodami susisiekite su savo failų valdytoju',
      phone: 'Telefonas',
      email: 'El. paštas',
    },
    globalSustainabilityReport: {
      sustainabilityReport: 'Tvarumo ataskaita',
      date: 'Data',
      startDate: 'Pradžios data',
      endDate: 'Pabaigos data',
      orderCount: 'Užsakymų skaičius',
      truck: 'Sunkvežimis',
      totals: 'Iš viso',
      distance: 'Atstumas',
      weight: 'Svoris',
      emissions: 'CO2 emisijos',
      averagePerOrder: 'Vidurkis vienam užsakymui',
      framework: 'Išsamesnės informacijos apie emisijų skaičiavimą ieškokite mūsų svetainės tvarumo politikoje.',
      questionsOrComments: 'Klausimai ar komentarai?',
      contactFileManager: 'Nedvejodami susisiekite su savo failų valdytoju',
      phone: 'Tel.',
      email: 'El. paštas',
    },
    rideOverview: {
      title: 'Apžvalga',
      entryNumber: 'Apžvalgos nuoroda',
      dossier: 'Byla',
      draftBanner: 'Juodraštis — dar nepatvirtintas',
      invoiceRequestNotice:
        'Šis dokumentas nėra galiojanti savarankiško apmokėjimo (self-billing) sąskaita faktūra. Gavus šią apžvalgą, {{customer}} tikisi iš jūsų sąskaitos faktūros už šiuos užsakymus.',
    },
    selfBill: {
      title: 'Self-billing sąskaita',
      number: 'Nr.',
      draftBanner: 'Juodraštis — dar nepatvirtintas',
      supplierLabel: 'Tiekėjas — vežėjas · mes mokame šiai įmonei',
      customerLabel: 'Pirkėjas — išrašo šią sąskaitą tiekėjo vardu',
      vatCompanyNumber: 'PVM / įmonės kodas:',
      vatShort: 'PVM',
      carrierNumber: 'Vežėjo numeris: {{number}}',
      customerRegister: 'RLE Gent, division Kortrijk',
      bankLabel: 'Mokėjimas į tiekėjo banko sąskaitą',
      bankNotice:
        'Užregistruota mūsų vežėjų byloje. Jei tai ne jūsų sąskaita, nedelsdami susisiekite su {{email}}. Banko duomenys keičiami tik pagal mūsų patikros procedūrą, niekada pagal el. laišką.',
      documentType: 'Dokumento tipas',
      invoiceNumber: 'Sąskaitos numeris',
      invoiceDate: 'Sąskaitos data',
      servicePeriod: 'Paslaugų laikotarpis',
      agreement: 'Sutartis',
      paymentDate: 'Mokėjimo data',
      natureOfServices:
        'Paslaugų pobūdis: {{nature}}, vienas reisas vienoje eilutėje, atliktas nurodytą siuntimo dieną. Vieneto kaina = eilutės suma (kiekis 1), be PVM.',
      roadFreightTransport: 'krovinių vežimas keliais',
      columnNumber: 'Nr.',
      columnFile: 'Byla',
      columnShipmentDate: 'Siuntimo data',
      columnLoading: 'Pakrovimas',
      columnUnloading: 'Iškrovimas',
      columnQuantity: 'Kiek.',
      columnVat: 'PVM',
      columnAmount: 'EUR',
      tripCountOne: 'Reisų šioje sąskaitoje: 1',
      tripCountOther: 'Reisų šioje sąskaitoje: {{count}}',
      totalServices: 'Iš viso transporto paslaugų (be PVM)',
      earlyPaymentDiscount: 'Nuolaida už ankstyvą mokėjimą {{percentage}}',
      earlyPaymentCondition:
        'Apmokant per 7 dienas, išskaičiuojama {{percentage}} ({{amount}}) nuolaida. Mokėtina: {{withDiscount}}. Praėjus šiam terminui: {{withoutDiscount}}.',
      taxableAmount: 'Apmokestinamoji vertė {{rate}}',
      vat: 'PVM {{rate}}',
      totalToPay: 'Iš viso mokėti',
      paymentNotice: '{{amount}} bus automatiškai pervesta {{date}} į sąskaitą {{iban}}. Jums nieko daryti nereikia.',
      paymentNoticeWithoutAccount: '{{amount}} bus automatiškai pervesta {{date}}. Jums nieko daryti nereikia.',
      yourInvoiceTitle: 'Tai jūsų sąskaita. Nesiųskite mums sąskaitos už šiuos reisus.',
      yourInvoice:
        'Šį dokumentą {{supplier}} vardu ir sąskaita išrašo {{customer}} pagal abiejų šalių sutartį dėl sąskaitų išrašymo. Tai nėra pasiūlymas. Jūsų pačių atsiųsta sąskaita už tuos pačius reisus bus atmesta kaip dublikatas.',
      acceptanceTitle: 'Priėmimas',
      acceptance:
        'Laikoma, kad tiekėjas šią sąskaitą priėmė, nebent per 7 dienas nuo sąskaitos datos ji raštu užginčijama adresu {{email}}. Pataisymai atliekami pirkėjo išrašyta kreditine sąskaita.',
      paymentTermTitle: 'Mokėjimo terminas',
      paymentTerm:
        'Taikomas jūsų sutartyje nustatytas mokėjimo terminas. Jei suteikta nuolaida, mokėjimo terminas yra 7 dienos.',
      missingTripTitle: 'Trūksta reiso?',
      missingTrip:
        'Reisas neįtrauktas į šią sąskaitą, nes jo dokumentai netvarkingi. Įkelkite teisingus dokumentus į vežėjų portalą ir reisas bus įtrauktas į kitą jūsų sąskaitą.',
      questionsTitle: 'Klausimai?',
      questions: 'Rašykite {{email}}, nurodydami sąskaitos numerį.',
      legalSelfBilling: 'Self-billing',
      legalNotice:
        '{{selfBilling}} — sąskaitą išrašė pirkėjas tiekėjo vardu ir sąskaita (Direktyvos 2006/112/EB 224 ir 226 straipsnio 10a punktas) · Sutartis {{agreement}} · Peppol BIS Self-Billing 3.0, dokumento tipas 389',
      legalTerms:
        'Bendrosios pardavimo sąlygos pridedamos ir pateiktos {{website}} · Taikoma Belgijos teisė · Kortreiko teismai',
      pageFooter: '{{title}} {{number}} · {{company}}',
      page: '{{page}} psl. iš {{total}}',
    },
    creditNote: {
      creditNote: 'Kreditinė sąskaita',
      customerNumber: 'Kliento numeris',
      creditNoteNumber: 'Kreditinės sąskaitos numeris',
      date: 'Data',
      dueDate: 'Apmokėjimo terminas',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      ourReference: 'Mūsų nuoroda',
      yourReference: 'Jūsų nuoroda',
      description: 'Aprašymas',
      quantity: 'Kiekis',
      unitPrice: 'Vieneto kaina',
      total: 'Iš viso',
      vat: 'PVM',
      paymentInformation: 'Mokėjimo informacija',
      amountToPay: 'Mokėtina suma',
      toBePaidBefore: 'Apmokėti iki',
      payer: 'Mokėtojas',
      message: 'Pranešimas',
      generalTermsAndConditions: 'Pridedamos bendrosios pardavimo sąlygos',
      questionsOrComments: 'Kilus klausimams, susisiekite su apskaita el. paštu {{email}}',
    },
    carrierTruckReport: {
      title: 'Truck performance report',
      truckname: 'Name',
      totalIncome: 'Total income',
      totalKm: 'Total kilometers',
    },
    totals: {
      totalExclVat: 'Iš viso be PVM',
      totalVat: 'PVM suma',
      totalInclVat: 'Iš viso su PVM',
      cashDiscount: 'Nuolaida už ankstyvą apmokėjimą',
      netAmountToPay: 'Mokėtina neto suma',
      vatReverseCharged: 'Atvirkštinis PVM, PVM direktyvos 44 straipsnis',
    },
  },
  carrierTerms: {
    agreement: 'Sutinku su {{terms}}, įskaitant savitarnos sąskaitų tvarką.',
    termsLink: 'bendrosiomis sąlygomis',
  },
  pages: {
    confirmOrderStates: {
      headingRefused: 'Užsakymas atmestas',
      headingCancelled: 'Užsakymas atšauktas',
      headingConfirmed: 'Užsakymas patvirtintas',
      headingUnknownStatus: 'Užsakymas jau įvykdytas arba būsena nežinoma',
    },
    confirmOrderPlanningStates: {
      headingRefused: 'Planavimas atmestas',
      headingCancelled: 'Planavimas atšauktas',
      headingConfirmed: 'Planavimas patvirtintas',
      headingUnknownStatus: 'Planavimas jau įvykdytas arba būsena nežinoma',
    },
    confirmOrder: {
      heading: 'Patvirtinti transporto užsakymą {{order.orderNumber}}',
      orderConfirmed: 'Užsakymas patvirtintas',
      orderConfirmationError: 'Nepavyko patvirtinti užsakymo: {{error}}',
      confirmButton: `Patvirtinti transporto užsakymą`,
    },
    confirmPlanning: {
      heading: 'Patvirtinti planavimą {{planningDate}}',
      planningConfirmed: 'Planavimas patvirtintas',
      confirmButton: `Patvirtinti planavimą`,
    },
    refuseOrder: {
      heading: 'Atmesti transporto užsakymą {{order.orderNumber}}',
      orderRefused: 'Užsakymas atmestas',
      orderRefusalError: 'Nepavyko atmesti užsakymo: {{error}}',
      refuseButton: `Atmesti transporto užsakymą`,
    },
    refusePlanning: {
      heading: 'Atmesti planavimą {{planningDate}}',
      planningRefused: 'Planavimas atmestas',
      refuseButton: `Atmesti planavimą`,
    },
    orderSummary: {
      loadAndUnloadInformation: 'Pakrovimo ir iškrovimo informacija',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      freightRate: 'Frachto tarifas',
      total: 'Iš viso',
    },
  },
  portal: {
    requestAccount: {
      requestCustomerAccount: 'Prašyti kliento paskyros',
      requestCarrierAccount: 'Prašyti vežėjo paskyros',
      success: 'Prašymas išsiųstas, susisieksime su jumis dėl tolimesnių veiksmų.',
      failed: 'Nepavyko paprašyti paskyros: {{error}}',
      name: 'Vardas',
      email: 'El. paštas',
      companyName: 'Įmonės pavadinimas',
      companyNumber: 'Įmonės kodas',
      request: 'Prašyti',
      dontHaveAnAccount: 'Dar neturite paskyros?',
      accountRequestFailed: 'Paskyros užklausa nepavyko',
    },
  },
  customerPortal: {
    switch: 'Perjungti klientą',
    selectCustomer: 'Pasirinkite klientą',
    requestAccount: {
      title: 'Prašyti paskyros',
      success: 'Prašymas pateiktas, susisieksime su jumis dėl tolimesnių veiksmų.',
      failed: 'Nepavyko paprašyti paskyros: {{error}}',
      name: 'Vardas',
      email: 'El. paštas',
      companyName: 'Įmonės pavadinimas',
      companyNumber: 'Įmonės kodas',
      request: 'Prašyti',
      dontHaveAnAccount: 'Dar neturite paskyros?',
    },
    invite: {
      title: 'Pakviestas į klientų portalą',
      details: 'Jūs buvote pakviestas į TransDirect klientų portalą, sukurkite savo paskyrą įvesdami slaptažodį.',
      accepted: 'Kvietimas priimtas, netrukus būsite nukreiptas į pagrindinį puslapį.',
      acceptError: 'Nepavyko priimti kvietimo: {{error}}',
      acceptButtonText: 'Priimti kvietimą',
      password: 'Slaptažodis',
      repeatPassword: 'Pakartoti slaptažodį',
    },
    home: {
      customerPortal: 'Klientų portalas',
      title: 'Klientų portalas',
      hello: 'Sveiki,',
      welcome: 'Sveiki atvykę į klientų portalą.',
      manageOrders: 'Valdykite visus savo transporto užsakymus.',
      viewInvoices: 'Lengvai peržiūrėkite ir apmokėkite sąskaitas.',
      createQuotes: 'Kurkite ir stebėkite pasiūlymus.',
      viewLocations: 'Peržiūrėkite visas transporto vietas.',
    },
    locations: {
      locations: 'Vietos',
      location: 'Vieta',
      name: 'Pavadinimas',
      street: 'Gatvė',
      number: 'Numeris',
      countryCode: 'Šalies kodas',
      postalCode: 'Pašto kodas',
      city: 'Miestas',
      country: 'Šalis',
      language: 'Kalba',
      notes: 'Pastabos',
      createLocation: 'Sukurti vietą',
      newLocation: 'Nauja vieta',
      locationCreated: 'Vieta sukurta',
      couldNotCreateLocation: 'Nepavyko sukurti vietos: {{error}}',
      findLocation: 'Rasti vietą...',
      address: 'Adresas',
      locationNotFound: 'Vieta nerasta',
      couldNotLoadLocation: 'Nepavyko įkelti vietos: {{error}}',
    },
    order: {
      duplicate: 'Dubliuoti',
      bulkDuplicate: 'Masinis dubliavimas',
      bulkDuplicateTitle: 'Masinis užsakymo dubliavimas',
      bulkDuplicateDescription: 'Sukurkite kelias šio užsakymo kopijas su didėjančiomis sąskaitų nuorodomis.',
      numberOfDuplicates: 'Dublikatų skaičius',
      baseInvoiceRef: 'Pradinė sąskaitos nuoroda',
      baseInvoiceRefHelper: 'Skaitinė bazė. Priekiniai nuliai bus pašalinti. Nuorodos bus bazė iki bazė+kiekis-1.',
      skipDraft: 'Praleisti juodraščio būseną (tiesiogiai kaip Sukurta)',
      bulkDuplicateSuccess: '{{count}} užsakymų sukurta',
      bulkDuplicateError: 'Nepavyko dubliuoti užsakymų: {{error}}',
      referencePreview: 'Nuorodos: {{first}} iki {{last}}',
      overview: 'Apžvalga',
      updateInvoiceRef: 'Atnaujinti sąskaitos nuorodą',
      updated: 'Užsakymas atnaujintas',
      couldNotUpdate: 'Nepavyko atnaujinti užsakymo: {{error}}',
    },
    orders: {
      orders: 'Užsakymai',
      placeOrder: 'Pateikti užsakymą',
      invoiceRef: 'Sąskaitos nuoroda',
      orderRef: 'Užsakymo nuoroda',
      loadLocation: 'Pakrovimo vieta',
      unloadLocation: 'Iškrovimo vieta',
      loadDate: 'Pakrovimo data',
      loadTime: 'Pakrovimo laikas',
      unloadDate: 'Iškrovimo data',
      unloadTime: 'Iškrovimo laikas',
      invoiceTotal: 'Sąskaitos suma',
      status: 'Būsena',
      invoiceStatus: 'Sąskaitos būsena',
      hasCMR: 'Turi CMR',
      creationDate: 'Sukūrimo data',
      executionDate: 'Įvykdymo data',
      fileManager: 'Failų valdytojas',
      cancellationReason: 'Atšaukimo priežastis',
      stops: 'Sustojimai',
      deleteStop: 'Ištrinti sustojimą',
      purchases: 'Pirkimai',
      total: 'Iš viso',
      trailerTypes: 'Priekabų tipai',
      loadingMethod: 'Pakrovimo būdas',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      typeStop: 'Sustojimo tipas',
      extraNotes: 'Papildomos pastabos',
      noContent: 'Nėra turinio',
      packaging: 'Pakuotė',
      coli: 'Koliai',
      content: 'Turinys',
      addContent: 'Pridėti turinį',
      deleteContent: 'Ištrinti turinį',
      noStops: 'Nėra sustojimų',
      noStopsError: 'Pridėkite bent vieną pakrovimo ir iškrovimo sustojimą',
      reference: 'Nuoroda',
      complaints: 'Skundai',
      fileComplaint: 'Pateikti skundą',
      fileComplaintDescription: 'Užpildykite šią formą, kad pateiktumėte skundą',
      send: 'Siųsti',
      reason: 'Priežastis',
      details: 'Išsami informacija',
      complaintFiled: 'Skundas pateiktas',
      couldNotFileComplaint: 'Nepavyko pateikti skundo: {{error}}',
      placeAnOrder: 'Pateikti užsakymą',
      assignment: 'Pavedimas',
      addStop: 'Pridėti sustojimą',
      location: 'Vieta',
      date: 'Data',
      start: 'Pradžia',
      stop: 'Pabaiga',
      weight: 'Svoris (kg)',
      volume: 'Tūris (m3)',
      loadMeter: 'Pakrovimo metrai',
      stopsRequired: 'Reikalingas bent 1 sustojimas',
      contentRequired: 'Reikalingas bent 1 turinio elementas',
      truck: 'Sunkvežimis',
      distance: 'Atstumas',
      emissions: 'Emisijos',
      sustainability: 'Tvarumas',
      attachments: 'Priedai',
      uploadAttachments: 'Įkelti priedus',
      attachmentDeleted: 'Priedas ištrintas',
      couldNotDeleteAttachment: 'Nepavyko ištrinti priedo: {{error}}',
      uploadedAttachment: 'Priedas {{document}} įkeltas',
      uploadFailed: 'Nepavyko įkelti priedo {{document}}: {{error}}',
      route: 'Maršrutas',
      chooseMethod: 'Pasirinkite metodą',
      automatic: 'Automatiškai',
      automaticDescription:
        'Įkelkite vieną ar daugiau transporto užsakymo PDF failų ir mūsų DI automatiškai išgaus užsakymo informaciją. Kiekvienas PDF tampa atskiru užsakymu.',
      manual: 'Rankiniu būdu',
      manualDescription: 'Užpildykite užsakymo formą patys su visomis stotelėmis, kroviniu ir pristatymo detalėmis.',
      uploadPdfs: 'Įkelti transporto užsakymo PDF failus',
      processingPdf: 'PDF apdorojamas...',
      createOrders: 'Sukurti užsakymus',
      orderCreated: 'Užsakymas sukurtas',
      ordersCreated: '{{count}} užsakymų sukurta',
      couldNotCreateFromPdf: 'Nepavyko sukurti užsakymo iš PDF: {{error}}',
      uploadAtLeastOnePdf: 'Įkelkite bent vieną PDF',
      viewOrder: 'Peržiūrėti užsakymą',
      creatingOrders: 'Kuriami užsakymai...',
      report: 'Ataskaita',
      orderPlaced: 'Užsakymas pateiktas',
      couldNotPlaceOrder: 'Nepavyko pateikti užsakymo: {{error}}',
      stopNumber: 'Sustojimas {{number}} - {{type}}',
      orderLink: 'Užsakymas {{orderNumber}} - {{customerRef}}',
    },
    quotes: {
      quotes: 'Pasiūlymai',
      quote: 'Pasiūlymas',
      quoteReference: 'Pasiūlymo nuoroda',
      quoteDate: 'Pasiūlymo data',
      expirationDate: 'Galiojimo pabaigos data',
      total: 'Iš viso',
      search: 'Ieškoti pasiūlymo...',
      quotation: 'Pasiūlymas {{reference}}',
      notFound: 'Pasiūlymas nerastas',
      departurePlace: 'Išvykimo vieta',
      destination: 'Paskirties vieta',
      distance: 'Atstumas',
      price: 'Kaina',
      type: 'Tipas',
      requests: 'Užklausti pasiūlymai',
      request: 'Prašyti pasiūlymo',
      requestTitle: 'Pasiūlymo užklausa {{reference}}',
      notes: 'Pastabos',
      lines: 'Pasiūlymo eilutės',
      addLine: 'Pridėti eilutę',
      noLines: 'Nėra pasiūlymo eilučių',
      requestSuccess: 'Pasiūlymas užklaustas',
      requestFailed: 'Nepavyko užklausti pasiūlymo: {{error}}',
      requestedAt: 'Užklausta',
      quotationRequests: 'Pasiūlymų užklausos',
      hasQuote: 'Turi pasiūlymą',
      generalInformation: 'Bendra informacija',
      removeLine: 'Pašalinti eilutę',
    },
    quoteLine: {
      from: 'Nuo',
      to: 'Iki',
    },
    invoices: {
      invoices: 'Sąskaitos',
      invoiceNumber: 'Sąskaitos numeris',
      invoiceDate: 'Sąskaitos data',
      dueDate: 'Apmokėjimo terminas',
      total: 'Iš viso',
      search: 'Ieškoti sąskaitos...',
      notFound: 'Sąskaita nerasta',
      invoice: 'Sąskaita {{invoiceNumber}}',
      structuredComment: 'Struktūrizuotas komentaras',
      reference: 'Nuoroda',
      sentAt: 'Išsiųsta',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      description: 'Aprašymas',
      amount: 'Suma',
      unitPrice: 'Vieneto kaina',
      vat: 'PVM',
      extraInformation: 'Papildoma informacija: {{extraInformation}}',
      orderTotal: 'Užsakymo suma: €{{total}}',
      totalExclVat: 'Iš viso be PVM:',
      totalVat: 'PVM suma:',
      totalInclVat: 'Iš viso su PVM:',
      generalInformation: 'Bendra informacija',
    },
    creditNotes: {
      creditNotes: 'Kreditinės sąskaitos',
      creditNoteNumber: 'Kreditinės sąskaitos numeris',
      creditNoteDate: 'Kreditinės sąskaitos data',
      dueDate: 'Apmokėjimo terminas',
      total: 'Iš viso',
      search: 'Ieškoti kreditinės sąskaitos...',
      notFound: 'Kreditinė sąskaita nerasta',
      creditNote: 'Kreditinė sąskaita {{creditNoteNumber}}',
      structuredComment: 'Struktūrizuotas komentaras',
      reference: 'Nuoroda',
      sentAt: 'Išsiųsta',
      load: 'Pakrovimas',
      unload: 'Iškrovimas',
      description: 'Aprašymas',
      amount: 'Suma',
      unitPrice: 'Vieneto kaina',
      vat: 'PVM',
      extraInformation: 'Papildoma informacija: {{extraInformation}}',
      orderTotal: 'Užsakymo suma: €{{total}}',
      totalExclVat: 'Iš viso be PVM:',
      totalVat: 'PVM suma:',
      totalInclVat: 'Iš viso su PVM:',
      generalInformation: 'Bendra informacija',
    },
    businessInformation: {
      businessInformation: 'Verslo informacija',
      updateBusinessInformation: 'Atnaujinti verslo informaciją',
      name: 'Pavadinimas',
      vatNumber: 'PVM mokėtojo kodas',
      businessNumber: 'Įmonės kodas',
      saveChanges: 'Išsaugoti pakeitimus',
      informationChanged: 'Informacija atnaujinta',
      informationNotChanged: 'Nepavyko atnaujinti informacijos: {{error}}',
      requestChanges: 'Norėdami atnaujinti įmonės pavadinimą, PVM mokėtojo kodą ar įmonės kodą, susisiekite su mumis',
    },
    ourInformation: {
      ourInformation: 'Bendrovės informacija TransDirect',
      name: 'Pavadinimas',
      vatNumber: 'PVM mokėtojo kodas',
      businessNumber: 'Įmonės kodas',
      address: 'Adresas',
      contact: 'Kontaktas',
      phoneNumber: 'Telefono numeris',
      emailTransport: 'Transporto el. paštas',
      emailAccounting: 'Apskaitos el. paštas',
      emailGeneral: 'Bendrasis el. paštas',
    },
    contacts: {
      contacts: 'Kontaktai',
      name: 'Vardas',
      email: 'El. paštas',
      phone: 'Telefonas',
      function: 'Pareigos',
      language: 'Kalba',
      notifications: 'Kontaktas tinkamas',
      newContact: 'Naujas kontaktas',
      contactCreated: 'Kontaktas sukurtas',
      couldNotCreateContact: 'Nepavyko sukurti kontakto: {{error}}',
      createContact: 'Sukurti kontaktą',
      notFound: 'Kontaktas nerastas',
      updatedContact: 'Kontaktas atnaujintas',
      couldNotUpdateContact: 'Nepavyko atnaujinti kontakto: {{error}}',
      updateContact: 'Atnaujinti kontaktą',
      delete: 'Ištrinti',
      deleteContact: 'Ištrinti kontaktą',
      deleteContactConfirmation: 'Ar tikrai norite ištrinti kontaktą {{name}}?',
      deleteContactError: 'Nepavyko ištrinti kontakto: {{error}}',
      deleteContactSuccess: 'Kontaktas ištrintas',
    },
    users: {
      users: 'Vartotojai',
      inviteUser: 'Kviesti vartotoją',
      invitedUsers: 'Pakviesti vartotojai',
      noInvitedUsers: 'Nėra pakviestų vartotojų',
      removeInvite: 'Pašalinti kvietimą',
      confirmRemoveInvite: 'Ar tikrai norite pašalinti kvietimą {{email}}?',
      inviteRemoved: 'Kvietimas pašalintas',
      couldNotRemoveInvite: 'Nepavyko pašalinti kvietimo: {{error}}',
      noUsersFound: 'Vartotojų nerasta',
      removeUser: 'Pašalinti vartotoją',
      confirmRemoveUser: 'Ar tikrai norite pašalinti vartotoją {{name}}?',
      userRemoved: 'Vartotojas pašalintas',
      couldNotRemoveUser: 'Nepavyko pašalinti vartotojo: {{error}}',
      active: 'Aktyvus',
      inactive: 'Neaktyvus',
      userInvited: 'Vartotojas pakviestas',
      couldNotInviteUser: 'Nepavyko pakviesti vartotojo: {{error}}',
      name: 'Vardas',
      email: 'El. paštas',
      isActive: 'Ar aktyvus?',
      invited: 'Pakviestas',
    },
    cmrReminder: {
      cmrReminder: 'CMR priminimas',
      sendReminder: 'Siųsti',
      confirmText: 'Ar tikrai norite siųsti CMR priminimą?',
      confirmation: 'CMR priminimas išsiųstas',
      error: 'Nepavyko išsiųsti CMR priminimo: {{error}}',
    },
    sustainability: {
      sustainability: 'Tvarumas',
      policy: 'Tvarumo politika',
      viewOverview: 'Peržiūrėti tvarumo apžvalgą',
      orderCount: 'Užsakymų skaičius',
      totalDistance: 'Bendras atstumas',
      totalWeight: 'Bendras svoris',
      totalEmissions: 'Bendros CO2 emisijos',
      averageDistance: 'Vidutinis atstumas',
      averageWeight: 'Vidutinis svoris',
      averageEmissions: 'Vidutinės CO2 emisijos',
      total: 'Iš viso',
      avgPerOrder: 'Vidurkis vienam užsakymui',
    },
    settings: {
      settings: 'Nustatymai',
    },
    apiKeys: {
      apiKeys: 'API raktai',
      createApiKey: 'Sukurti API raktą',
      name: 'Pavadinimas',
      scopes: 'Leidimai',
      status: 'Būsena',
      lastUsed: 'Paskutinį kartą naudotas',
      createdAt: 'Sukurta',
      prefix: 'Priešdėlis',
      active: 'Aktyvus',
      revoked: 'Atšauktas',
      expired: 'Pasibaigęs',
      never: 'Niekada',
      revokeApiKey: 'Atšaukti API raktą',
      confirmRevoke: 'Ar tikrai norite atšaukti API raktą "{{name}}"? Šio veiksmo negalima atšaukti.',
      apiKeyRevoked: 'API raktas buvo atšauktas',
      couldNotRevoke: 'Nepavyko atšaukti API rakto: {{error}}',
      apiKeyCreated: 'API raktas buvo sukurtas',
      couldNotCreate: 'Nepavyko sukurti API rakto: {{error}}',
      copyKey: 'Kopijuoti raktą',
      keyCopied: 'Raktas nukopijuotas',
      keyWarning: 'Saugiai išsaugokite šį raktą. Jis daugiau nebebus rodomas.',
      noApiKeys: 'API raktų nerasta',
      ordersRead: 'Skaityti užsakymus',
      ordersWrite: 'Kurti užsakymus',
      maxKeysReached: 'Pasiektas didžiausias API raktų skaičius',
      scopeRequired: 'Reikalinga bent viena sritis',
    },
    loading: 'Kraunama...',
  },
  liveTracking: {
    title: 'Sekimas',
    subtitle: 'Šio vilkiko vieta ir borto kompiuteris.',
    loading: 'Gaunama vieta…',
    noPosition: 'Šiam vilkikui vieta dar nežinoma.',
    noPositionHint: 'Integracijų puslapyje susiekite transporto priemonę su šiuo valstybiniu numeriu.',
    noConnection: 'Šio vilkiko dar neseka jokia sekimo jungtis. Prijunkite jungtį, kad matytumėte vietą.',
    driving: 'Važiuoja',
    idle: 'Stovi',
    location: 'Vieta',
    speed: 'Greitis',
    heading: 'Kryptis',
    odometer: 'Odometras',
    fuel: 'Degalai',
    lastMeasurement: 'Paskutinis matavimas',
    liveActive: 'Sekimas realiuoju laiku įjungtas — atnaujinama kas 30 sekundžių.',
    lastSignal: 'Paskutinis signalas',
    trailer: 'Priekaba',
    refresh: 'Atnaujinti',
    startLive: 'Įjungti sekimą realiuoju laiku',
    stopLive: 'Išjungti sekimą realiuoju laiku',
    resizePanel: 'Keisti šoninės panelės dydį',
    connections: 'Sekimo jungtys',
    connectionsSubtitle: 'Prijunkite tiekėjo sekimo aplinką, kad galėtumėte sekti jų vilkikus.',
    addConnection: 'Pridėti sekimo jungtį',
    integrations: 'Sekimo integracijos',
    integrationsHint: 'Pasirinkite teikėją, kad prijungtumėte tiekėjo sekimą.',
    providerFleetmaster: 'Sekite vilkikų vietą ir borto kompiuterį per FleetMaster.lt.',
    connectionLabel: 'Pavadinimas',
    connectionLabelHelp: 'Kaip ši jungtis bus rodoma sąraše.',
    helpCompanyId: 'Įmonės ID iš jūsų FleetMaster telematikos paskyros.',
    helpSuivoBaseUrl: 'Palikite tuščią, jei naudojatės standartine Suivo aplinka.',
    ownerLabel: 'Tiekėjo ID',
    ownerHelp: 'Jungčiai, priklausančiai užsakovui / tiekėjui.',
    credentialsNote: 'Raktas saugomas užšifruotas ir po išsaugojimo daugiau niekada nerodomas.',
    connect: 'Prijungti',
    back: 'Atgal',
    noConnections: 'Sekimo jungties dar nėra.',
    noConnectionsHint: 'Pridėkite ją, kad matytumėte, kur yra vilkikai.',
    moreConnectionsTitle: 'Daugiau sekimo jungčių – netrukus',
    moreConnectionsBody:
      'FleetMaster yra pirmasis teikėjas. Dirbame prie daugiau sekimo jungčių — nauji teikėjai čia atsiras automatiškai.',
    connectionsLoading: 'Jungtys įkeliamos…',
    vehiclesLoading: 'Transporto priemonės įkeliamos…',
    noVehicles: 'Ši jungtis kol kas nepraneša apie transporto priemones.',
    statusActive: 'Aktyvi',
    statusError: 'Klaida',
    keyLabel: 'raktas',
    linkedCount: '{{linked}} iš {{total}} transporto priemonių susieta',
    lastChecked: 'paskutinė patikra',
    never: 'niekada',
    supplierOwner: 'Tiekėjas #{{id}}',
    connectionSettings: 'Jungties nustatymai',
    verify: 'Patikrinti',
    verifyOk: 'Jungtis veikia.',
    verifyFailed: 'Jungties patikrinti nepavyko.',
    remove: 'Ištrinti',
    removeTitle: 'Ištrinti jungtį',
    removeDescription: 'Jungtis „{{label}}“ ir išsaugotas raktas bus ištrinti.',
    connectionRemoved: 'Jungtis ištrinta.',
    linkVehicles: 'Susieti transporto priemones',
    linkVehiclesHint: 'Pasirinkite transporto priemonę, tada vilkiką, kuriame ji važiuoja.',
    link: 'Susieti',
    unlink: 'Atsieti',
    linkTruck: 'Susieti vilkiką',
    chooseTruck: 'Vilkikas',
    chooseTruckHelp: 'Pasirinkite vilkiką, kuriame važiuoja ši transporto priemonė.',
    chooseTruckRequired: 'Pasirinkite vilkiką',
    moreTrucks: 'Rodomi tik pirmieji {{count}} vilkikai — ieškokite, kad susiaurintumėte sąrašą.',
    plateMatch: 'valstybinis numeris sutampa',
    linkedTo: 'Susieta su {{truck}}',
    linkedManually: 'rankinis',
    notLinked: 'Nesusieta',
    vehicleLinked: 'Transporto priemonė susieta.',
    vehicleUnlinked: 'Susiejimas panaikintas.',
    trailerSubtitle: 'Šios priekabos vieta.',
    linkTracker: 'Susieti sekiklį',
    linkTrackerHint: 'Pasirinkite transporto priemonę, esančią šioje priekaboje.',
    linkTrailer: 'Susieti priekabą',
    linkTrailerHint: 'Pasirinkite transporto priemonę, tada priekabą, ant kurios ji yra.',
    chooseTrailer: 'Priekaba',
    chooseTrailerRequired: 'Pasirinkite priekabą',
    noTrackerLinked: 'Su šia priekaba dar nesusietas joks sekiklis — susiekite, kad matytumėte vietą.',
    noTrailerPosition: 'Šios priekabos vieta dar nežinoma.',
    searchUnits: 'Ieškoti pagal pavadinimą ar numerį…',
    noUnits: 'Kol kas nepranešta jokių transporto priemonių.',
    providerSuivo: 'Stebėkite mūsų priekabų vietą naudodami Suivo sekiklius.',
    ownerKindLabel: 'Savininkas',
    ownerKindCompany: 'Nuosavas parkas (įmonė)',
    ownerKindCarrier: 'Vežėjas/tiekėjas',
    supplierOwnerCompany: 'Nuosavas parkas',
    status: {
      moving: 'Važiuoja',
      parked: 'Pastatyta',
      idling: 'Tuščia eiga',
      immobilized: 'Užblokuota',
      offline: 'Nėra signalo',
      inOperation: 'Eksploatuojama',
    },
    trailersMap: {
      searchLabel: 'Ieškoti (TDR ID / pavadinimas / numeris)',
      searchPlaceholder: 'Ieškoti pagal pavadinimą ar numerį...',
      trackerLabel: 'Sekiklis',
      trackerAll: 'Visos priekabos',
      trackerTracked: 'Su sekikliu',
      trackerUntracked: 'Be sekiklio',
      trackerSilent: 'Nėra signalo > 24 val.',
      tableCardTitle: 'Priekabos',
      mapCardTitle: 'Žemėlapis',
      tableTrailer: 'Priekaba',
      tablePlate: 'Numeris',
      tableTracker: 'Sekiklis',
      tableStatus: 'Būsena',
      tableLastSignal: 'Paskutinis signalas',
      tablePlace: 'Vieta',
      noTracker: 'Nėra sekiklio',
      clearFilters: 'Išvalyti visus filtrus',
      noneTrackedTitle: 'Sekiklis dar neprijungtas',
      noneTrackedDescription: 'Prijunkite „Suivo“ įrenginį prie priekabos, kad jį matytumėte žemėlapyje.',
      noneInFilter: 'Šioje atrankoje priekabų nėra',
      noConnectionsTitle: 'Dar nėra sekimo ryšio',
      noConnectionsDescription: 'Pridėkite ryšį, kad matytumėte, kur yra mūsų priekabos.',
      noConnectionsAction: 'Į sekimo integracijas',
      connectionErrorTitle: 'Sekimo ryšys su klaida',
    },
  },
  carrierPortal: {
    liveTracking: { liveTracking: 'Sekimas' },
    selectCarrier: 'Pasirinkti vežėją',
    loading: 'Kraunama...',
    switch: 'Pakeisti vežėją',
    home: {
      carrierPortal: 'Vežėjo portalas',
      title: 'Vežėjo portalas',
      hello: 'Sveiki,',
      welcome: 'Sveiki atvykę į vežėjo portalą.',
      manageOrders: 'Valdykite visus savo transporto užsakymus.',
      managePlanning: 'Valdykite savo planavimą.',
      selfBilling: 'Kurkite ir valdykite savo savarankiško apmokėjimo sąskaitas.',
      info: 'Informacija',
      infoSubtitle: 'Informacija apie TransDirect ir vežėjo portalą',
      contact: 'Kontaktinis asmuo',
      contactSubtitle: 'Kas yra jūsų TransDirect kontaktinis asmuo',
      FuelCard: 'Kuro kortelė',
      FuelCardSubtitle: 'Užsisakykite savo asmeninę TransDirect kuro kortelę',
      saveChanges: 'Išsaugoti pakeitimus',
    },
    orders: {
      allAccepted: 'Visi užsakymai patvirtinti',
      customerReference: 'Kliento nuoroda',
      draft: 'Ruošinys',
      load: 'Pakrovimas',
      orders: 'Užsakymai',
      manageOrders: 'Valdykite visus savo transportus ir įkelkite transporto dokumentus',
      orderRef: 'TD-Nuoroda',
      loadLocation: 'Pakrovimo vieta',
      unload: 'Iškrovimas',
      unloadLocation: 'Iškrovimo vieta',
      invoiceTotal: 'Frachto tarifas',
      hasCMR: 'Turi dokumentus',
      documents: 'Dokumentai',
      cmrRejected: 'Atmesta',
      cmrPending: 'Tvarkoma',
      cmrUploadHint: 'Galite įkelti vieną ar kelis PDF failus; mes juos sujungsime į vieną dokumentą.',
      cmrUploaded: 'Dokumentas įkeltas',
      cmrUploadFailed: 'Nepavyko įkelti dokumento: {{error}}',
      documentValidation: 'Dokumentai',
      documentValidationNoDocuments: 'Nėra dokumentų',
      documentValidationPending: 'Tvarkoma',
      documentValidationApproved: 'Patvirtinta',
      documentValidationRejected: 'Atmesta',
      outstandingDocsTitle: 'Documents still required',
      requiredDocMissing: 'missing',
      requiredDocInReview: 'under review',
      requiredDocRejected: 'rejected — please re-upload',
      requiredDocStatusReceived: 'Received',
      requiredDocStatusInReview: 'In review',
      requiredDocStatusRejected: 'Rejected',
      requiredDocStatusMissing: 'Missing',
      requiredDocsTitle: 'Required documents',
      requiredDocsSubtitle: 'This customer requires the documents below for this order.',
      requiredDocsProgress: '{{done}} of {{total}} received',
      requiredDocReupload: 'Upload again',
      uploadDocumentTitle: 'Upload {{document}}',
      uploadRequiredDoc: 'Upload',
      uploadDocumentsTitle: 'Įkelti dokumentus',
      uploadDocumentsHint:
        'Įkelkite vieną ar kelis failus iš karto; mes juos išskaidysime ir kiekvieną dalį priskirsime tinkamam dokumento tipui.',
      docReasonInReview: 'tikrinama',
      docReasonRejected: 'atmesta',
      docRejectionLowQuality: 'neįskaitoma',
      docRejectionMissingSignature: 'trūksta parašo',
      docRejectionNoOrderReference: 'nerasta nuoroda',
      docRejectionNotNeutral: 'neneutralus CMR',
      docRejectionWrongCustomer: 'ne tas klientas',
      docRejectionWrongDeliveryAddress: 'neteisingas pristatymo adresas',
      docRejectionWrongDocumentType: 'netinkamas dokumento tipas',
      docRejectionWrongOrgOnDocument: 'ne ta įmonė',
      requiredDocUploaded: 'Document uploaded',
      requiredDocUploadFailed: 'Document could not be uploaded: {{error}}',
      purchases: 'Frachto tarifas',
      reference: 'Nuoroda',
      assignee: 'Priskirta',
      orderAssigned: 'Užsakymas priskirtas',
      changeAssignee: 'Keisti',
      assignOrder: 'Priskirti užsakymą',
      assign: 'Priskirti',
      route: 'Maršrutas',
      error: 'Klaida',
      report: 'Ataskaita',
    },
    planning: {
      acceptAll: 'Patvirtinti visus',
      actions: 'Veiksmai',
      date: 'Data',
      loadingOrders: 'Užsakymai kraunami...',
      noTruck: 'Šis vežėjas dar neturi sunkvežimio.',
      ordersForTruck: 'Užsakymai sunkvežimiui su numeriu {{licensePlate}}',
      planning: 'Planavimas',
      truck: 'Sunkvežimis',
      managePlanning: 'Peržiūrėkite ir valdykite savo transporto planavimą',
    },
    selfBilling: {
      selfBilling: 'Savarankiškas apmokėjimas',
      rideOverview: 'Reisų apžvalga',
      manageRideOverview: 'Peržiūrėkite ir atsisiųskite savo reisų apžvalgas',
      searchRideOverviewPlaceholder: 'Ieškoti reisų apžvalgos...',
      type: 'Tipas',
      number: 'Numeris',
      manageSelfBilling: 'Peržiūrėkite ir atsisiųskite savo savarankiško apmokėjimo sąskaitas',
      searchPlaceholder: 'Ieškoti savarankiško apmokėjimo...',
      id: 'Nuoroda',
      date: 'Data',
      download: 'Atsisiųsti',
      invoice: 'Sąskaita',
      title: 'Savarankiško apmokėjimo sąskaita',
    },
    businessInformation: {
      businessInformation: 'Verslo informacija',
      settingsAndBusinessInformation: 'Nustatymai ir verslo informacija',
      tabGeneral: 'Bendra',
      tabFleet: 'Autoparkas',
      tabContacts: 'Kontaktai',
      civilLiabilityInsurance: 'Civilinės atsakomybės draudimas',
      CMRInsurance: 'CMR draudimas',
      transportationInsurance: 'Transportavimo draudimas',
      documentUploaded: 'Dokumentas įkeltas',
      insurances: 'Draudimai',
    },
    generalInformation: {
      generalInformation: 'Informacija',
      noDocumentsAvailable: 'Dokumentų nėra',
      checkBackLater: 'Grįžkite vėliau, kad rastumėte atnaujintą dokumentaciją',
    },

    contacts: {
      contacts: 'Kontaktai',
      newContact: 'Naujas kontaktas',
      updateContact: 'Išsaugoti kontaktą',
      name: 'Vardas',
      email: 'El. paštas',
      phone: 'Telefonas',
      function: 'Pareigos',
      language: 'Kalba',
      delete: 'Ištrinti',
      createContactSuccess: 'Kontaktas sėkmingai sukurtas',
      createContactError: 'Klaida kuriant kontaktą: {{error}}',
      updateContactSuccess: 'Kontaktas sėkmingai atnaujintas',
      updateContactError: 'Klaida atnaujinant kontaktą: {{error}}',
      deleteContact: 'Ištrinti kontaktą',
      deleteContactConfirmation: 'Ar tikrai norite ištrinti savo kontaktą?',
      deleteContactSuccess: 'Kontaktas sėkmingai ištrintas',
      deleteContactError: 'Klaida trinant kontaktą: {{error}}',
      notFound: 'Kontaktas nerastas',
      notifications: 'Pranešimai',
    },
    trucks: {
      title: 'Sunkvežimiai',
      newTruck: 'Naujas sunkvežimis',
      update: 'Atnaujinti sunkvežimį',
      licensePlate: 'Valstybinis numeris',
      codeName: 'Kodinis pavadinimas',
      planner: 'Planuotojas',
      isActive: 'Aktyvus',
      insuranceExpiresAt: 'Draudimas galioja iki',
      examinationExpiresAt: 'Techninė apžiūra galioja iki',
      documents: 'Dokumentai',
      yes: 'Taip',
      no: 'Ne',
      moveUp: 'Perkelti aukštyn',
      moveDown: 'Perkelti žemyn',
      create: 'Sukurti',
      succeeded: 'Sunkvežimis išsaugotas',
      createError: 'Nepavyko sukurti sunkvežimio: ',
      updateError: 'Nepavyko atnaujinti sunkvežimio: ',
      insurance: 'Draudimas',
      insuranceUploaded: 'Draudimas išsaugotas',
      examination: 'Techninė apžiūra',
      examinationUploaded: 'Techninė apžiūra išsaugota',
      notFound: 'Sunkvežimių nerasta',
      appLoginTitle: 'Vairuotojo programėlės prisijungimas',
      appLoginHint:
        'Vairuotojai prisijungia su valstybiniu numeriu. Nustatykite slaptažodį čia; vairuotojai negali jo patys atkurti.',
      appPasswordLabel: 'Vairuotojo programėlės slaptažodis',
      appLoginLabel: 'Prisijungimas (valstybinis numeris)',
      appCodeNameLabel: 'Kodinis pavadinimas',
      appSavePassword: 'Išsaugoti slaptažodį',
      appDisableLogin: 'Išjungti prisijungimą',
      appPasswordSaved: 'Slaptažodis išsaugotas',
      appLoginDisabled: 'Vairuotojo programėlės prisijungimas išjungtas',
      detailsTitle: 'Vilkiko duomenys',
      documentCount: '{{count}} iš {{total}}',
      statusValid: 'Galioja',
      statusExpiringSoon: 'Netrukus baigsis',
      statusExpired: 'Nebegalioja',
      statusMissing: 'Trūksta',
      expiresOn: 'Galioja iki {{date}}',
      noDocument: 'Dokumentas dar neįkeltas',
      viewDocument: 'Peržiūrėti',
      replaceDocument: 'Pakeisti',
      uploadDocument: 'Įkelti',
      searchPlaceholder: 'Ieškoti pagal valstybinį numerį…',
      noExpiryKnown: 'Galiojimo data nežinoma',
      notUploadedYet: 'Dar neįkelta',
    },
    trailers: {
      title: 'Priekabos',
      truckAmount: 'Sunkvežimių skaičius',
      tautlinerAmount: 'Tentinių priekabų skaičius',
      boxTrailerAmount: 'Kietasienių/šaldytuvų priekabų skaičius',
      openTrailerAmount: 'Atvirų priekabų skaičius',
      save: 'Išsaugoti pakeitimus',
      saveSuccess: 'Vežėjas atnaujintas',
      saveError: 'Nepavyko atnaujinti vežėjo: {{error}}',
      subtitle: 'Kiekiai pagal tipą — naudojami pajėgumų planavimui',
    },
    driverBlock: {
      title: 'Vairuotojo prieiga',
      message: 'Prisijunkite prie vairuotojo programėlės savo telefone, kad galėtumėte peržiūrėti užsakymus.',
    },
    notFound: {
      pageNotFound: 'Puslapis nerastas.',
      pageNotFoundDesc:
        'Atrodo, kad šis puslapis (dar) neegzistuoja. Jei manote, kad kažkas negerai, susisiekite su savo TransDirect kontaktiniu asmeniu.',
    },
    invite: {
      title: 'Pakviestas į vežėjo portalą',
      details: 'Jūs buvote pakviestas į TransDirect vežėjo portalą, sukurkite savo paskyrą įvesdami slaptažodį.',
      accepted: 'Kvietimas priimtas, netrukus būsite nukreiptas į pagrindinį puslapį.',
      acceptError: 'Nepavyko priimti kvietimo: {{error}}',
      acceptButtonText: 'Priimti kvietimą',
      password: 'Slaptažodis',
      repeatPassword: 'Pakartoti slaptažodį',
    },
    users: {
      users: 'Vartotojai',
      inviteUser: 'Kviesti vartotoją',
      invitedUsers: 'Pakviesti vartotojai',
      noInvitedUsers: 'Nėra pakviestų vartotojų',
      removeInvite: 'Pašalinti kvietimą',
      confirmRemoveInvite: 'Ar tikrai norite pašalinti kvietimą {{email}}?',
      inviteRemoved: 'Kvietimas pašalintas',
      couldNotRemoveInvite: 'Nepavyko pašalinti kvietimo: {{error}}',
      noUsersFound: 'Vartotojų nerasta',
      removeUser: 'Pašalinti vartotoją',
      confirmRemoveUser: 'Ar tikrai norite pašalinti vartotoją {{name}}?',
      userRemoved: 'Vartotojas pašalintas',
      couldNotRemoveUser: 'Nepavyko pašalinti vartotojo: {{error}}',
      active: 'Aktyvus',
      inactive: 'Neaktyvus',
      userInvited: 'Vartotojas pakviestas',
      couldNotInviteUser: 'Nepavyko pakviesti vartotojo: {{error}}',
      name: 'Vardas',
      email: 'El. paštas',
      isActive: 'Ar aktyvus?',
      role: 'Vaidmuo',
      roleDispatcher: 'Dispečeris',
      roleDriver: 'Vairuotojas',
      activeUsers: 'Aktyvūs vartotojai',
      pendingInvitations: 'Laukiantys kvietimai',
      sendInvitation: 'Siųsti kvietimą',
      sending: 'Siunčiama...',
      cancel: 'Atšaukti',
      emailAddress: 'El. pašto adresas',
      deleteInvitation: 'Ištrinti kvietimą',
      joined: 'Prisijungė',
      invited: 'Pakviestas',
      assignee: 'Priskirta',
      assignOrder: 'Priskirti užsakymą',
      unassigned: 'Nepriskirta',
      assignedTo: 'Priskirta',
      roleUpdated: 'Rolė atnaujinta',
      renameUser: 'Pervardyti naudotoją',
      newName: 'Naujas vardas',
      userRenamed: 'Naudotojas pervardintas',
      save: 'Išsaugoti',
      permissions: 'Leidimai',
      canRenameUsers: 'Gali pervardyti naudotojus',
      permissionsUpdated: 'Leidimai atnaujinti',
      nameOptional: 'Vardas (neprivaloma)',
      emailRequired: 'Įveskite el. pašto adresą',
      namePlaceholder: 'Jonas Jonaitis',
      emailPlaceholder: 'naudotojas@pavyzdys.com',
    },
    tracking: {
      loading: 'Įkeliami sekimo įvykiai...',
      events: 'Sekimo įvykiai',
      noEvents: 'Sekimo įvykių nerasta',
      scheduled: 'Suplanuota',
      eventTypes: {
        StatusLoaded: 'Pakrauta',
        StatusUnloaded: 'Iškrauta',
        LocationPing: 'Vietos atnaujinimas',
      },
      stop: 'Stotelė',
      by: 'pagal',
    },
  },
  carrierContactNotifications: {
    transportOrders: 'Transporto užsakymai',
    selfBillings: 'Savarankiški apmokėjimai',
  },
  orderStatus: {
    Draft: 'Ruošinys',
    Created: 'Sukurta',
    Prepayment: 'Išankstinis apmokėjimas',
    Placed: 'Pateikta',
    Confirmed: 'Patvirtinta',
    Refused: 'Atmesta',
    Executed: 'Įvykdyta',
    Cancelled: 'Atšaukta',
  },
  orderSaleStatus: {
    Created: 'Sukurta',
    Credited: 'Kredituota',
    Incomplete: 'Nebaigta',
    Invoiced: 'Išrašyta sąskaita',
  },
  customerContactNotifications: {
    invoice: 'Sąskaita',
    orderConfirmation: 'Užsakymo patvirtinimas',
    cmr: 'CMR',
    quotation: 'Pasiūlymas',
    dieselSurcharge: 'Dyzelino priemoka',
    paymentReminder: 'Mokėjimo priminimas',
  },
  errors: {
    required: 'Privaloma',
    invalidEmail: 'Neteisingas el. paštas',
    dateShouldBeInTheFuture: 'Data turi būti ateityje',
    startTimeShouldBeBeforeEndTime: 'Pradžios laikas turi būti prieš pabaigos laiką',
    passwordsDontMatch: 'Slaptažodis ir pakartotas slaptažodis nesutampa.',
    passwordTooShort: 'Slaptažodis per trumpas.',
    formValidation: 'Patikrinkite pažymėtus formos laukus',
    retry: 'Bandyti dar kartą',
    reloadPage: 'Perkrauti puslapį',
    networkTitle: 'Ryšio problema',
    networkDescription: 'Nepavyksta pasiekti serverio. Patikrinkite interneto ryšį ir bandykite dar kartą.',
    serverTitle: 'Serverio klaida',
    serverDescription: 'Serveris negalėjo apdoroti jūsų užklausos. Bandykite vėliau.',
    notFoundTitle: 'Nerasta',
    notFoundDescription: 'Prašomi duomenys nebeegzistuoja arba nėra pasiekiami.',
    sessionTitle: 'Sesija baigėsi',
    sessionDescription: 'Jūsų sesija baigėsi arba nesate prisijungę. Prisijunkite iš naujo, kad tęstumėte.',
    permissionTitle: 'Nėra prieigos',
    permissionDescription: 'Neturite prieigos prie šių duomenų.',
    validationTitle: 'Neteisingi duomenys',
    validationDescription: 'Patikrinkite įvestus duomenis ir bandykite dar kartą.',
    rateLimitTitle: 'Per daug užklausų',
    rateLimitDescription: 'Išsiųsta per daug užklausų. Palaukite ir bandykite dar kartą.',
    abortedTitle: 'Užklausa atšaukta',
    abortedDescription: 'Užklausa buvo atšaukta. Jei reikia, bandykite dar kartą.',
    unknownTitle: 'Nežinoma klaida',
    unknownDescription: 'Įvyko netikėta klaida. Bandykite dar kartą arba kreipkitės į pagalbą, jei tai kartojasi.',
    loadingTitle: 'Įkelti nepavyko',
    loadingDescription: 'Duomenų nepavyko įkelti.',
  },
  orderComplaintType: {
    Aggression: 'Fizinė/verbalinė agresija',
    DamagedGoods: 'Pažeistos prekės',
    IncorrectDelivery: 'Neteisingas pristatymas',
    IncorrectInvoice: 'Neteisinga sąskaita',
    LateDelivery: 'Vėluojantis pristatymas',
    Other: 'Kita',
  },
  myProfile: {
    myProfile: 'Mano profilis',
    logout: 'Atsijungti',
    name: 'Vardas',
    role: 'Rolė',
    email: 'El. paštas',
    language: 'Kalba',
    languageChanged: 'Kalba atnaujinta',
    languageNotChanged: 'Nepavyko atnaujinti kalbos: {{error}}',
    joinedAt: 'Prisijungė',
    nameChanged: 'Vardas atnaujintas',
    nameNotChanged: 'Nepavyko atnaujinti vardo: {{error}}',
  },
  auth: {
    forgotPassword: {
      title: 'Pamiršote slaptažodį',
      requestNewPassword: 'Prašyti naujo slaptažodžio',
      instructions:
        'Įveskite savo el. pašto adresą. Jei vartotojas egzistuoja sistemoje, netrukus gausite el. laišką, kuriame galėsite nustatyti naują slaptažodį.',
      requestFailed: 'Nepavyko paprašyti naujo slaptažodžio',
      instructionsSent: 'Instrukcijos, kaip nustatyti naują slaptažodį, buvo išsiųstos jūsų el. pašto adresu.',
    },
    configNewPassword: {
      title: 'Nustatyti naują slaptažodį',
      newPassword: 'Naujas slaptažodis',
      repeatNewPassword: 'Pakartoti naują slaptažodį',
      confirmButtonText: 'Nustatyti naują slaptažodį',
      passwordDontMatch: 'Slaptažodis ir pakartotas slaptažodis turi sutapti',
      tokenNotFound: 'Žetonas nerastas',
      invalidToken: 'Žetonas nebegalioja',
      configFailed: 'Nepavyko nustatyti slaptažodžio: {{error}}',
    },
    login: {
      login: 'Prisijungti',
      email: 'El. paštas',
      password: 'Slaptažodis',
      forgotPassword: 'Pamiršote slaptažodį',
      customerLoginTitle: 'Klientų prisijungimas',
      loginWithGoogle: 'Prisijungti su Google',
      incorrectCredentials: 'El. paštas arba slaptažodis neteisingas',
      loginFailed: 'Nepavyko prisijungti: {{error}}',
    },
    userNotFound: {
      title: 'Vartotojas nerastas',
      description: 'Nepavyko prisijungti, įvyko klaida arba vartotojas nebeegzistuoja.',
      goToLoginPage: 'Eiti į prisijungimo puslapį',
    },
  },
  upload: {
    title: 'Įkelti',
    dropzoneHint: 'Spustelėkite čia arba vilkite failą (-us) į lauką, kad įkeltumėte',
    uploadDocuments: 'Įkelti dokumentus',
    confirmDeleteDocument: 'Ar tikrai norite ištrinti šį dokumentą?',
    deleteDocument: 'Ištrinti dokumentą',
    noDocumentsFound: 'Dokumentų nerasta',
    noDocumentsSelected: 'Nepasirinkta jokių dokumentų',
    uploadFailed: 'Nepavyko įkelti dokumento',
    uploadDocumentFailed: 'Nepavyko įkelti failo {{filename}}: {{reason}}',
    multiUploadFailed: 'Nepavyko įkelti failų: {{reason}}',
  },
  or: 'arba',
  draft: 'Juodraštis',
  cancel: 'Atšaukti',
  close: 'Uždaryti',
  moreInfo: 'Daugiau informacijos',
  previous: 'Ankstesnis',
  next: 'Kitas',
  delete: 'Ištrinti',
  save: 'Išsaugoti',
  download: {
    open: 'Atidaryti',
    download: 'Atsisiųsti',
    started: 'Atsisiuntimas pradėtas',
    failed: 'Atsisiuntimas nepavyko: {{message}}',
  },
  chat: {
    title: 'Pokalbis',
    sendMessage: 'Siųsti žinutę',
    placeholder: 'Įveskite žinutę...',
    noMessages: 'Žinučių dar nėra',
    loadMore: 'Įkelti daugiau žinučių',
    messageSent: 'Žinutė išsiųsta',
    messageError: 'Nepavyko išsiųsti žinutės: {{error}}',
    newMessage: '{{name}}: nauja žinutė užsakyme {{orderNumber}}',
    internal: 'Vidinis',
    carrier: 'Vežėjas',
  },
};
